
import {getProductByID, toAwning, toBlind } from '../shop-front-component/ProductCollection'

import GenericProductPage from './GenericProductPage'

export default function ProtectaXLPage() {

  return (
      GenericProductPage(getProductByID(53),toAwning)
  )
}
